<template>
  <div class="cart-order-block__pickup">
  <!--Выбор тк-->
    <ul class="tk-table">
      <li class="tk-table__item">
        <div class="tk-table__radio">
          <input type="radio"
                 name="tk"
                 id="tk_dpd"
                 value="10"
                 v-model="deliveryCompany"
          >
          <label for="tk_dpd" class="tk-table__input-label">
            <span class="tk-table__item tk-table__logo">
                <img src="../../../images/base/delivery/dpd.png"
                     alt="dpd"
                     class="tk-table__logo-img"
                >
            </span>
            <span class="tk-table__item tk-table__name texts_heading-13">
                DPD
            </span>
          </label>
        </div>
      </li>
      <li class="tk-table__item">
        <div class="tk-table__radio">
          <input type="radio"
                 name="tk"
                 id="tk_cdek"
                 value="20"
                 v-model="deliveryCompany"
          >
          <label for="tk_cdek" class="tk-table__input-label">
            <span class="tk-table__item tk-table__logo">
                <img src="../../../images/base/delivery/cdek.png"
                     alt="dpd"
                     class="tk-table__logo-img"
                >
            </span>
            <span class="tk-table__item tk-table__name texts_heading-13">
                Cdek
            </span>
          </label>
        </div>
      </li>
    </ul>

    <!--Если выбрана тк рендерим инпут с выбором города-->
    <div v-if="deliveryCompany && receiving === 10">
      <!--Если выбран город - рендерим карту с точками-->
      <TheDeliveryPoints/>
    </div>
  </div>
</template>

<script>
import ItemErrors from "./ItemErrors.vue";
import TheCartOrderMap from "./TheCartOrderMap.vue";
import PickupPointIcon from "../icons/PickupPointIcon.vue";
import DeliveryPoints from "./TheDeliveryPoints.vue";
import TheDeliveryPoints from "./TheDeliveryPoints.vue";
import cartService from "../../services/cart.service";
import {addressErrorMixin} from "../../mixins/addressErrorMixin";
import {log10} from "chart.js/helpers";

export default {
  name: "TheCartOrderReceivingPickup",
  components: {
    TheDeliveryPoints,
    DeliveryPoints,
    PickupPointIcon,
    ItemErrors,
    TheCartOrderMap
  },
  mixins: [addressErrorMixin],
  watch: {
    async deliveryCompany(value) {
      if (this.receiving === 20) {
        const isAllowed = await this.isAllowed(
            value,
            this.daDataResult.federal_district,
            this.daDataResult.city
        );
        if (isAllowed === true) {
          await this.fetchDeliveryCost(value, this.daDataResult, this.address);
        } else {
          this.setAddressError('К сожалению, не можем отправить по этому адресу');
        }
      }
    }
  },
  computed: {
    deliveryCompany: {
      get () {
        return this.$store.state.order.deliveryCompany;
      },
      set (value) {
        this.$store.commit('order/setDeliveryCompany',  parseInt(value, 10))
      }
    },
    address: {
      get () {
        return this.$store.state.order.address;
      }
    },
    receiving: {
      get () {
        return this.$store.state.order.receiving
      },
    },

    errors: {
      get () {
        return this.$store.state.order.errors
      },
    },
    daDataResult: {
      get () {
        return this.$store.state.order.daDataResult;
      },
    }
  },
  methods: {
    async fetchDeliveryCost(val, daDataResult, address) {
      this.setLoading(true);
      this.setLoadingText('Рассчитываем доставку...')
      try {
        const response = await cartService.fetchDeliveryCost(val, daDataResult, address);
        const data = response.data;
        this.$store.commit('cart/setDeliveryPrice', data.price);
        this.$store.commit('order/setDeliveryPrice', data.price);
        this.setLoading(false);
      } catch (error) {
        console.error("Error fetching delivery cost:", error);
      }
    },
    setLoading(value) {
      this.$store.commit('cart/setLoading', value);
    },
    setLoadingText(value) {
      this.$store.commit('cart/setLoadingText', value);
    },
    async isAllowed(val, district, city) {
      try {
        const response = await cartService.isAllowed(val, district, city);
        return response.data;
      } catch (error) {
        console.error("Error fetching is allowed address:", error);
      }
    }
  },
}
</script>
